<button type="button" mat-flat-button color="primary" (click)="onSubmit()">{{ label }}</button>
